import { useState } from 'react';
import member1 from '../assets/team/Amanda.png';
import member2 from '../assets/team/Jani.jpeg';
import member3 from '../assets/team/jessi.jpg';
import member4 from '../assets/team/Jorge.jpg';

// Ejemplo de datos de trabajadores
const workers = [
    {
        name: "Amanda Perez",
        role: "CEO",
        photo: member1,
        info: "CEO of Timeline Estudio, a seasoned marketing strategist based in Madrid, Spain. With extensive experience in digital marketing, branding, and communications, she has successfully led projects across a wide range of industries. She specializes in crafting strategies that genuinely connect brands with their audiences through creativity, innovation, and purpose. Today, she guides Timeline Estudio with a clear vision: helping businesses and entrepreneurs build a strong, authentic, and impactful digital presence.",
    },
    {
        name: "Jani",
        role: "Co-Founder & Public Relations Director",
        photo: member2,
        info: "Executive with experience in planning, developing, managing, and monitoring national media campaigns. Skilled in leading press departments for live events and shows, as well as in the management and promotion of television personalities and artists. Expert in designing strategies and campaigns across mass media, print, and radio. Experienced logistics coordinator and video production director, with a solid network.",
    },
    {
        name: "Jessica Fernández",
        role: "Full Stack Web-Developer & QA Specialist",
        photo: member3,
        info: "Jessica develops modern and efficient web solutions. According to client needs, she creates attractive and functional websites.",
    },
    {
        name: "Jorge Calaña",
        role: "Graphic and Motion Designer",
        photo: member4,
        info: "Graphic & Motion Designer with experience in conceptualizing, developing, and executing creative campaigns across digital and print media. Skilled in creating visual identities, brand assets, and multimedia content that communicate ideas with clarity and impact. Expert in visual storytelling and design strategy, with a strong understanding of branding, social media content, and audience engagement. Experienced in coordinating creative projects from concept to final delivery, ensuring cohesive and visually compelling results across all platforms.",
    },
];

const About = () => {
  const [showInfo, setShowInfo] = useState(Array(workers.length).fill(false));

  const toggleInfo = idx => {
    setShowInfo(prev =>
      prev.map((v, i) => (i === idx ? !v : v))
    );
  };

  return (
    <div
      className="about_page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F5F5DC'
      }}
    >
      <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', position: 'relative'}}>
        <h1 style={{ color: "#0000FF", textAlign: "center",fontSize: "8rem", fontWeight: "bold" }}>Who are we?</h1>
        <p style={{ color: "#0000FF", textAlign: "center", lineHeight: "1.6", marginTop: "1rem" }}>
          At Timeline Estudio, we turn ideas into stories that connect.
          We’re a creative marketing and advertising agency dedicated to making your life easier when it comes to social media.
          Our mission is to help your business build a strong digital presence, so you’re not wasting money on ads that don’t deliver results.
          We create valuable, high-performing content designed to position your brand for success through creativity and innovation.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '2rem', marginTop: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {workers.map((worker, idx) => (
          <div key={worker.name} style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            padding: '1rem',
            width: '220px',
            textAlign: 'center',
            position: 'relative'
          }}>
                  <img
              src={worker.photo}
              alt={worker.name}
              style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '8px' }}
            />

            <h3 style={{ margin: '0.5rem 0 0 0' }}>{worker.name}</h3>
            <p style={{ color: '#ed4e01', margin: '0.5rem 0' }}>{worker.role}</p>
            <button
              style={{
                background: '#ed4e01',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.5rem 1rem',
                cursor: 'pointer',
                marginBottom: '0.5rem'
              }}
              onClick={() => toggleInfo(idx)}
            >
              {showInfo[idx] ? "Hide Info" : "Show Info"}
            </button>
            {showInfo[idx] && (
              <div style={{
                background: '#f9f9f9',
                borderRadius: '8px',
                padding: '0.5rem',
                marginTop: '0.5rem',
                fontSize: '0.95rem'
              }}>
                {worker.info}
              </div>
            )}
          </div>
        ))}
      </div>
      <div style={{ height: '2rem' }}></div>
    </div>
  );
};

export default About;